import React from 'react';
export const Tag = ({ tagName, children, ...props }) => React.createElement(tagName, props, children);

